import { render, staticRenderFns } from "./FrameworkCompetencyPropertyListItem.vue?vue&type=template&id=4f4d7af6"
import script from "./FrameworkCompetencyPropertyListItem.vue?vue&type=script&lang=js"
export * from "./FrameworkCompetencyPropertyListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports